import {isLocal, isS3Fast} from 'utils/env';
import {forceHttpsUrl} from 'utils/urls';

export const s3Urls = {
  fast: 'https://yastatic.net/s3/milab/',
  slow: 'https://milab.s3.yandex.net/',
  yandexLocal: 'https://s3.mds.yandex.net/milab/',
};

export function normalizeS3Url(url: string, mode: 's3' | 's3-fast' | 's3-slow') {
  let res = isLocal ? url : forceHttpsUrl(url);
  let targetPrefix: string;
  if (mode === 's3') {
    targetPrefix = isS3Fast ? s3Urls.fast : s3Urls.slow;
  } else if (mode === 's3-fast') {
    targetPrefix = s3Urls.fast;
  } else if (mode === 's3-slow') {
    targetPrefix = s3Urls.slow;
  }
  Object.values(s3Urls).forEach((prefix: string) => {
    if (res.startsWith(prefix)) {
      res = res.replace(prefix, targetPrefix);
    }
  });
  return res;
}
